export default __webpack_public_path__ + "static/media/tool-icon-keeper.ac03ee1e.svg";